/** Hook de roles: expone los roles y flags del usuario logueado. Los helpers puros (RolNombre, normalizarRol, tieneRol, distinguirRol) viven en el dominio. */
import type { Role } from "@/types";
import { useWorkSession } from "./useWorkSession";
import { distinguirRol, nombreRolPrincipal, tieneRol, type RolNombre } from "@/domain";

export {
  normalizarRol,
  tieneRol,
  distinguirRol,
  nombreRolPrincipal,
  type RolNombre,
} from "@/domain";

export interface UseRolesReturn {
  roles: Role[];
  rolPrincipal?: RolNombre;
  nombreRolPrincipal?: string;
  esAdmin: boolean;
  esSuperAdmin: boolean;
  esOperario: boolean;
  esGerente: boolean;
  esJefeTaller: boolean;
  esResponsableAgenda: boolean;
  esAsesorTecnico: boolean;
  tiene: (...nombres: RolNombre[]) => boolean;
}

export const useRoles = (): UseRolesReturn => {
  const { loggedUserInnerwork } = useWorkSession();
  const roles = loggedUserInnerwork?.roles ?? [];

  const esSuperAdmin =
    roles.some((r) => r.esSuperAdmin === true) || tieneRol(loggedUserInnerwork, "superadmin");
  const esAdmin =
    roles.some((r) => r.esAdmin === true) ||
    esSuperAdmin ||
    tieneRol(loggedUserInnerwork, "administrador");
  const esOperario = tieneRol(loggedUserInnerwork, "operario");
  const esGerente = tieneRol(loggedUserInnerwork, "gerente");
  const esJefeTaller = tieneRol(loggedUserInnerwork, "jefe taller");
  const esResponsableAgenda = tieneRol(loggedUserInnerwork, "responsable agenda");
  const esAsesorTecnico = tieneRol(loggedUserInnerwork, "asesor tecnico");

  return {
    roles,
    rolPrincipal: distinguirRol(roles),
    nombreRolPrincipal: nombreRolPrincipal(roles),
    esAdmin,
    esSuperAdmin,
    esOperario,
    esGerente,
    esJefeTaller,
    esResponsableAgenda,
    esAsesorTecnico,
    tiene: (...nombres) => tieneRol(loggedUserInnerwork, ...nombres),
  };
};
